<script setup lang="ts">
import { RSnackbar } from '@revolugo/design-system/molecules'
</script>

<template>
  <RSnackbar class="z-50" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<style scoped></style>
